export default {
  tracesState(state) {
    return state.traces;
  },
};
